<template>
  <nav>
    <ul v-for="(date, index) in dateObjects" :key="index" :data-date='formattedDate(index, "dddd dd.mm.yy")'>
      <li v-for="(time, index) in date">
        <time v-html='formattedTime(time.start, "HH:MM")' />
        <h5 v-html='time.title' />
        <h6 v-html='time.subtitle' />
      </li>
    </ul>
  </nav>
</template>

<script>
import mixins from '.././mixins.js';
export default {
  mixins: [mixins], //kirby(), urltopath(), etc
  props: ['block'],
  computed: {
    dateObjects: function() {
      let eventsByDates = {};
      let self = this;
      Object.keys(this.block.content.rows).map(function(key){
        eventsByDates[self.block.content.rows[key].date] = eventsByDates[self.block.content.rows[key].date] || {};
        eventsByDates[self.block.content.rows[key].date][self.block.content.rows[key].start] = self.block.content.rows[key];
      });
      return eventsByDates
    }
  }
}
</script>

<style scoped>

  nav {
    padding: 0;
    margin-bottom: 2em;
  }

  ul {
    border-top: var(--thinline);
    padding: 0;
    margin: 0;
    list-style: none;
    margin-top: 2em;
    position: relative;
  }

  ul::before {
    content: attr(data-date) " ";
    position: absolute;
    display: block;
    padding: 0.25em;
  }

  time, h5, li {
    vertical-align: top;
    line-height: 1em;
  }

  time {
    width: 15%;
  }

  h5 {
    width: 85%;
    margin-bottom: 0;
  }

  li {
    border-bottom: var(--thinline);
    display: flex;
    padding: 0.5em;
    margin: 0;
    margin-left: 10em;
  }

</style>
